import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { ExternalAuthService } from './external-auth.service';
import { SnackBarService } from './snack-bar.service';
import { routeAuth } from './auth-routing';

// The logic lives in auth-routing.ts so it can be tested without Angular DI.
export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const snackBarService = inject(SnackBarService);

  return routeAuth(req, next, {
    apiEndpoint: environment.apiEndpoint,
    apiEndpointExternal: environment.apiEndpointExternal,
    getToken: () => authService.getToken(),
    logout: () => authService.logout(),
    external: inject(ExternalAuthService),
    notify: message => snackBarService.open(message, 'error'),
  });
};
